<template>
  <b-carousel
    id="carousel-gene"
    style="{text-shadow: 0px 0px 2px #000;}"
    :interval="8000"
    indicators
  >
    <b-carousel-slide :img-src="chromCircos"></b-carousel-slide>
    <b-carousel-slide :img-src="compareTree"></b-carousel-slide>
    <b-carousel-slide :img-src="RNAanalysis"></b-carousel-slide>
    <b-carousel-slide :img-src="HiCanalysis"></b-carousel-slide>
  </b-carousel>
</template>

<script>
import chromCircos from '@/assets/img/chromCircos.png'
import compareTree from '@/assets/img/compareTree.png'
import RNAanalysis from '@/assets/img/RNAanalysis.png'
import HiCanalysis from '@/assets/img/HiCanalysis.png'

export default {
  data() {
    return {
      chromCircos,
      compareTree,
      RNAanalysis,
      HiCanalysis
    }
  }
}
</script>

<style>

</style>